import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'products',
            name: 'product',
            class: 'Modules\\Product\\Entities\\Product',


            loadedLight: false
        }
    },

    methods: {
        getFormattedMeasureUnit(value) {
            switch(value) {
                case 'MGM':
                    value = 'Miligramos'
                break
        
                case 'GRM':
                    value = 'Gramos'
                break
        
                case 'KGM':
                    value = 'Kilogramos'
                break
        
                case 'MLT':
                    value = 'Mililitros'
                break
        
                case 'LTR':
                    value = 'Litros'
                break
        
                case 'XPK':
                    value = 'Paquete'
                break
        
                case 'H87':
                    value = 'Unidad'
                break
            }
        
            return value
        },

        getFormattedType(value) {
            // switch(value) {
            //     //
            // }
        
            return value
        },

        loadFeatured() {
            let page = _.get(this.placements, 'featured.current_page', 0)
            let products = _.get(this.placements, 'featured.data', [])
            let next_page_url = _.get(this.placements, 'featured.next_page_url', true)

            if(next_page_url) {
                this.$set(this.placements, 'featuredIsLoading', true)

                page ++

                this.loadIndex({
                    page: page,
                    paginate: 12,
                    placement: 'featured',
                    scopes: {
                        whereFeatured: 1
                    }
                })
                .then(response => {
                    this.placements.featured.data = products.concat(response.data)

                    return this.placements.featured
                })
                .finally(
                    () => this.$set(this.placements, 'featuredIsLoading', false)
                )
            }
        }
    }
}